"use strict";
var AjaxObservable_1 = require('./AjaxObservable');
exports.ajax = AjaxObservable_1.AjaxObservable.create;
//# sourceMappingURL=ajax.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/observable/dom/ajax.js
// module id = 4623
// module chunks = 168707334958949